import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { createSelector } from '@reduxjs/toolkit'
import { Grid } from '@mui/material'
import ClientCardComponent from './ClientCardComponent'

const selectedClientSelector = createSelector(
  [(state: RootState) => state.organization],
  (organization) => organization.selectedClient,
)

interface ClientsListProps {}

const clientsSelector = createSelector(
  [(state: RootState) => state.organization],
  (organization) => organization.clients,
)

const ClientsListComponent: React.FC<ClientsListProps> = ({}) => {
  const clients = useSelector(clientsSelector)
  const selectedClient = useSelector(selectedClientSelector)

  return (
    <Grid
      container
      spacing={'1rem'}
      sx={{
        overflowY: 'auto',
        boxSizing: 'border-box',
        pb: '1rem',
      }}
    >
      {clients.map((client, index) => (
        <Grid
          key={index}
          size={4}
          sx={{
            border:
              selectedClient?.id === client.id
                ? '2px solid #1705E5'
                : '2px solid transparent',
            borderRadius: '0.4rem',
            '&:hover': {
              border: '2px solid #1705E5',
            },
          }}
        >
          <ClientCardComponent client={client} />
        </Grid>
      ))}
    </Grid>
  )
}

export default ClientsListComponent
